import { css } from '@emotion/core';
import { Css, ITheme } from '../../../ui';
import { Color } from '../../../styles/Color';

export const NavigationItemFont = () => css`
	font-family: inherit;
	font-weight: 500;
	font-size: ${Css.pxToRem(16)};
	color: ${Color.OnBackground};
`;

export const MainNavigationItemCommon = (
	theme: ITheme,
	isActive?: boolean,
	withThemeColors?: boolean,
) => css`
	${NavigationItemFont()}

	display: inline-block;
	padding: ${Css.pxToRem(6)};
	position: relative;
	text-transform: capitalize;

	&:after {
		bottom: ${Css.pxToRem(4)};
		content: '';
		display: block;
		height: 2px;
		left: 50%;
		position: absolute;
		background: ${withThemeColors ? theme.color.brand : Color.OnBackground};
		transition: width 0.3s ease, left 0.3s ease;
		width: ${isActive ? '100%' : '0'};
		left: ${isActive ? '0' : '50%'};
	}
	:hover:after {
		width: 100%;
		left: 0;
	}

	:focus-visible {
		outline: 2px solid
			${withThemeColors ? theme.color.brand : Color.OnBackground};
		border-radius: ${theme.button.radius};
		background-color: ${withThemeColors
			? theme.color.primaryLight
			: Color.Neutral3};
	}

	svg {
		path {
			fill: currentColor;
		}
	}
`;
